import ArrowRightCircle from '@atom-web/icons-24/jsx/ArrowRightCircle'
import { Box, Flex } from '@atom-web/micros'
import Image from 'next/image'
import Slider from 'react-slick'
import styled from 'styled-components'

import { trackEvent } from '../../../utils/ML/EventsTracker'
import { EVENT_SB_CARD_SLIDER_IMAGES } from '../../../utils/ML/speedboatEvents'

const myLoader = ({ src, width, quality }) => {
	return `${src}?w=${width}&q=${quality || 75}`
}

export const SliderWrapper = styled.div`
	.resort-slider {
		height: ${({ isMobile }) => (isMobile ? '200px' : '250px')};

		/* Dots */
		.slick-dots {
			@media only screen and (min-width: 768px) {
				bottom: -10px;
			}
			li {
				margin: 0;
				button {
					&:before {
						font-size: 8px;
						color: rgba(255, 255, 255, 0.4);
						opacity: 1;
					}
				}
				&.slick-active button:before {
					color: rgba(255, 255, 255, 0.75);
					opacity: 1;
				}
			}
		}
	}
	.slick-next {
		right: 10px;
	}
	.slick-prev {
		left: 10px;
		z-index: 1;
	}
`

const ImageGradiant = styled.div`
	position: absolute;
	left: 0;
	top: 0;
	background-color: transparent;
	width: 100%;
	height: 100%;

	:before {
		position: absolute;
		top: 0;
		left: 0;
		content: '';
		background: linear-gradient(
			180deg,
			rgba(0, 0, 0, 0.4) 8%,
			rgba(0, 0, 0, 0) 29%
		);
		width: 100%;
		height: 100%;
	}

	:after {
		position: absolute;
		width: 100%;
		height: 64px;
		content: '';
		background: linear-gradient(
			180deg,
			rgba(0, 0, 0, 0) 0%,
			rgba(0, 0, 0, 0.79) 100%
		);
		left: 0;
		bottom: 0;
	}
`

const ImageSlider = ({ images, resortName, resortCode, isMobile }) => {
	const sliderSettings = {
		// slidesToShow: 1,
		// slidesToScroll: 1,
		dots: true,
		// arrows: true,
		// fixedHeight: true,
		afterChange: index => {
			trackEvent(EVENT_SB_CARD_SLIDER_IMAGES, {
				thumbnail_images_viewed: index,
				resort_name: resortName,
				resort_id: resortCode,
			})
		},
	}
	function Arrowright({ index }) {
		// let className = props.type === 'next' ? 'nextArrow' : 'prevArrow'
		// className += ' arrow'
		const char = <ArrowRightCircle />
		return (
			<Flex
				onClick={() => customPaging(index)}
				justify={'center'}
				align="center"
				css={{
					height: '30px',
					width: '30px',
					backgroundColor: 'Yellow',
					position: 'absolute',
					right: 10,
					borderRadius: '$round',
					cursor: 'pointer',
					top: '50%',
					transform: 'translate(0, 50%)',
				}}
			>
				<span>{char}</span>
			</Flex>
		)
	}
	const renderImages = images => {
		if (images && images.length > 5) {
			images.splice(5, images.length)
		}

		return (images || []).map((images, index) => {
			return (
				<Box
					css={{
						display: 'flex',
						width: '100%',
						height: '250px',
						position: 'relative',
						overflow: 'hidden',
						borderTopLeftRadius: '$3',
						borderTopRightRadius: '$3',
						'@lg': {
							borderBottomLeftRadius: '$3',
							height: '278px',
							borderTopRightRadius: 0,
						},
					}}
				>
					<Image
						layout="fill"
						src={images}
						alt={resortName}
						loader={myLoader}
					/>
					<ImageGradiant />
				</Box>
			)
		})
	}
	const customPaging = i => {
		return <span>{i + 1}</span>
	}

	return (
		<SliderWrapper isMobile={isMobile}>
			<Slider
				// customPaging={customPaging}
				nextArrow={<Arrowright type="next" />}
				{...sliderSettings}
				className="resort-slider"
			>
				{renderImages(images)}
			</Slider>
		</SliderWrapper>
	)
}

export default ImageSlider
